import { observable, computed, action } from 'mobx';
import { Notification } from '../models/interfaces';
import { API_URL } from '../constants/constants';

export class NotificationStore {

  @observable
  public notifications: Array<Notification>;

  constructor(initial: Notification[]) {
    this.notifications = initial;
  }

  @computed
  get allNotifications() {
    return this.notifications;
  }

  @computed
  get allUnseenNotifications() {
    return this.notifications.filter(notification => !notification.seen);
  }

  @action
  addNotification(notification: Notification) {
    this.notifications.push(notification);
  }

  @action
  dismissNotification(index: number) {
    this.allUnseenNotifications.map((notification, _index) => {
      if (index === _index) {
        notification.seen = true;
      }
    });
  }
}

export default NotificationStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/NotificationStore.ts